import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
const PlaceholderBox = styled.div(
  ({ theme }) => css`
    opacity: 0;
    transition:
      visibility 0s,
      opacity 0.2s linear;

    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 10px;

    background-color: ${theme.colors.global.contentBackground};
    color: ${theme.colors.gray[30]};
    margin-bottom: ${theme.spacings.xs};

    &:hover {
      opacity: 1;
    }

    cursor: pointer;
  `
);
const HugeIcon = styled(Icon)(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.huge};
    margin-bottom: 10px;
  `
);
const NewWidgetPlaceholder = ({ style = {}, position, component: Component }, ref) => {
  const [show, setShow] = useState(false);
  const onCancel = useCallback(() => setShow(false), []);
  const { t } = useTranslation("search");
  const onClick = useCallback(() => setShow(true), []);
  const containerStyle = {
    ...style,
    transition: "none"
  };
  return /* @__PURE__ */ React.createElement("div", { style: containerStyle, ref }, /* @__PURE__ */ React.createElement(PlaceholderBox, { onClick }, /* @__PURE__ */ React.createElement(HugeIcon, { name: "add_circle" }), t("widget_creation.placeholder")), show && /* @__PURE__ */ React.createElement(Component, { onCancel, position }));
};
export default React.forwardRef(NewWidgetPlaceholder);
